import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { AppRoutePath } from '@falcon/app/app.routing.model';
import { AuthService } from '@falcon/app/core/api/auth/auth.service';
import { AuthStore } from '@falcon/app/core/storage/auth/auth.store';

export const unauthorizedGuard: CanMatchFn = () => {
  const authService = inject(AuthService);
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    if (!authStore.getUser()) {
      authService.loadCurrentUser();
    }

    return authStore.getUserData$().pipe(map(() => true));
  }

  return router.createUrlTree([AppRoutePath.AUTH]);
};
